<template>
<div class="site-content">
  <div class="site-content-page">
    <div class="content-row">
      <div class="content-col col-per-70">
        <infoPageList-02 :showTitle="true" :showMore="false" :infoBlock="infoBlock" :infoPage="infoPage" title="行业资讯" label="INFORMARION" count="10" v-on:queryPage="hyzx_Req"/>
      </div>
      <div class="content-col col-per-30">
        <infoList title="最新快讯" label="FAST NEWS" :showTitle="true" :showMore="false" :infoBlock="infoBlock12" :infoPage="infoPage1" v-on:queryPage="zxkx_Req" titleLength="30" count="8"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import InfoBlock07 from '../block/InfoBlock07'

import InfoList from '../block/InfoList'
import InfoBlock12 from '../block/InfoBlock12'

export default {
  name: 'Hyzx01',
  components: {
    'infoPageList-02': InfoPageList02,
    'infoList': InfoList,
  },
  data() {
    return {
      msg: '',
      type:'news',
      infoBlock:InfoBlock07,
      infoPage:{},
      infoPage1:{},
      infoBlock12:InfoBlock12,
      pageSize:8
    }
  },
  methods:{
      //行业资讯
      hyzx_Req(params){
            let that=this;
            let result={page:params};
            console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
            that.$dataApi.articleList(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            result.list= res.data.list;
            result.page.total=res.data.total;
            that.infoPage=result;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
      //最新快讯
      zxkx_Req(params){
            var date = new Date();
            let that=this;
            params.queryYear=date.getFullYear();
            params.queryMonth=date.getMonth()+1;
            let result={page:params};
            console.log(params.title+'开始请求Vue-axios,参数：'+JSON.stringify(params));
            that.$dataApi.fastNewsLists(params).then(res =>{
            //console.log('请求Vue-axios结果：'+JSON.stringify(res))
            that.msg=res.msg;
            result.list= res.data.list;
            result.page.total=res.data.total;
            that.infoPage1=result;
            //console.log('结束请求Vue-axios：'+JSON.stringify(result))
            });
      },
    },
    created:function(){
      let params={page:1,pageSize:this.pageSize,type:this.type};
      this.hyzx_Req(params);
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col-per-70 {
  flex-grow:3;
}

.col-per-30 {
  flex-grow:1;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Hyzx01.vue